var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductIconOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16.341,
    viewBox: "0 0 18 16.341",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "folder",
    transform: "translate(-1.15 -2.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2706",
    "data-name": "Group 2706",
    transform: "translate(1.15 2.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2042",
    "data-name": "Path 2042",
    d: "M16.786,18.491H3.514A2.367,2.367,0,0,1,1.15,16.127V4.514A2.367,2.367,0,0,1,3.514,2.15H7.662a.705.705,0,0,1,.587.314L9.7,4.638h7.088A2.367,2.367,0,0,1,19.15,7v9.124A2.367,2.367,0,0,1,16.786,18.491ZM3.514,3.56a.955.955,0,0,0-.954.954V16.127a.955.955,0,0,0,.954.954H16.786a.955.955,0,0,0,.954-.954V7a.955.955,0,0,0-.954-.954H9.321a.705.705,0,0,1-.587-.314L7.284,3.56Z",
    transform: "translate(-1.15 -2.15)",
    fill: "#707070"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductIconOrder);
export default __webpack_public_path__ + "static/media/productIconOrder.3eb23f352e53de096e6b34526159672c.svg";
export { ForwardRef as ReactComponent };